module.exports = __webpack_public_path__ + "ab956541c2cfa0705e2faea0bfe0737a.jpg";